/* @flow */
import { combineEpics } from 'redux-observable';
import { Set } from 'immutable';
import { Observable } from 'rxjs';
import { prop } from 'ramda';
import { entityTypeListToOrderedMap } from './utils';
import { hasPermission } from 'modules/profile/getters';

import { FETCH_SUCCESS as FETCH_PROFILE_SUCCESS } from 'modules/profile/action-types.js';

import {

  FETCH_ENTITY_TYPES,
  FETCH_ENTITY_TYPES_SUCCESS,
  FETCH_ENTITY_TYPES_FAILURE,

  FETCH_SUBSCRIPTION_METHODS,
  FETCH_SUBSCRIPTION_METHODS_SUCCESS,
  FETCH_SUBSCRIPTION_METHODS_FAILURE,

  FETCH_CREDENTIALS_TYPES,
  FETCH_CREDENTIALS_TYPES_SUCCESS,
  FETCH_CREDENTIALS_TYPES_FAILURE,

  FETCH_ACCESS_TYPES,
  FETCH_ACCESS_TYPES_SUCCESS,
  FETCH_ACCESS_TYPES_FAILURE,

  FETCH_LABELS,
  FETCH_LABELS_SUCCESS,
  FETCH_LABELS_FAILURE,

} from './action-types.js';

import {
  fetchEntityTypes,
  fetchSubscriptionMethods,
  fetchCredentialsTypes,
  fetchAccessTypes,
  fetchLabels,
} from './actions.js';

const MISCELLANEOUS_ENDPOINT = '/services/miscellaneous';

const fetch = (action$, state$) =>
  action$.ofType(FETCH_PROFILE_SUCCESS)
    .mergeMap(() => {

      const state = state$.getState();

      // fetch for all users
      let actions = Set([
        fetchLabels(),
        fetchCredentialsTypes(),
      ]);

      // fetch for company admins
      if (hasPermission('manage_company_users')(state)) {
        actions = actions.union(Set([
          fetchAccessTypes(),
        ]));
      }

      // fetch for enclave managers
      if (hasPermission('manage_enclaves')(state)) {
        actions = actions.union(Set([
          fetchAccessTypes(),
          fetchEntityTypes(),
          fetchSubscriptionMethods(),
        ]));
      }

      // dedupe and convert to plain JS
      actions = actions
        .groupBy(x => x['type'])
        .toSet()
        .map(x => x.first())
        .toJS();

      return Observable.concat(actions);
    });

const fetchEntityTypesEpic = (action$, store, { ajax }) =>
  action$.ofType(FETCH_ENTITY_TYPES)
    .map(prop('payload'))
    .switchMap(() => {
      return ajax.get(`${MISCELLANEOUS_ENDPOINT}/entity-types`)
        .map(prop('response'))
        .map(entityTypeListToOrderedMap)
        .map(x => ({
          type: FETCH_ENTITY_TYPES_SUCCESS,
          payload: x,
        }))
        .catch(err => Observable.of({
          type: FETCH_ENTITY_TYPES_FAILURE,
          error: true,
          payload: err,
        }));
    });

const fetchCredentialsTypesEpic = (action$, store, { ajax }) =>
  action$.ofType(FETCH_CREDENTIALS_TYPES)
    .mergeMap(() =>
      ajax.get(`${MISCELLANEOUS_ENDPOINT}/credentials-types`)
        .map(({ response }) => ({
          type: FETCH_CREDENTIALS_TYPES_SUCCESS,
          payload: response,
        }))
        .catch(err => Observable.of({
          type: FETCH_CREDENTIALS_TYPES_FAILURE,
          error: true,
          payload: err,
        })));

const fetchAccessTypesEpic = (action$, store, { ajax }) =>
  action$.ofType(FETCH_ACCESS_TYPES)
    .mergeMap(() =>
      ajax.get(`${MISCELLANEOUS_ENDPOINT}/access-types`)
        .map(({ response }) => ({
          type: FETCH_ACCESS_TYPES_SUCCESS,
          payload: response,
        }))
        .catch(err => Observable.of({
          type: FETCH_ACCESS_TYPES_FAILURE,
          error: true,
          payload: err,
        })));

const fetchLabelsEpic = (action$, store, { ajax }) =>
  action$.ofType(FETCH_LABELS)
    .mergeMap(() =>
      ajax.get(`${MISCELLANEOUS_ENDPOINT}/enclave-labels`)
        .map(({ response }) => ({
          type: FETCH_LABELS_SUCCESS,
          payload: response,
        }))
        .catch(err => Observable.of({
          type: FETCH_LABELS_FAILURE,
          error: true,
          payload: err,
        })));

const fetchsubscriptionMethodsEpic = (action$, store, { ajax }) =>
  action$.ofType(FETCH_SUBSCRIPTION_METHODS)
    .mergeMap(() =>
      ajax.get(`${MISCELLANEOUS_ENDPOINT}/subscription-methods`)
        .map(({ response }) => ({
          type: FETCH_SUBSCRIPTION_METHODS_SUCCESS,
          payload: response,
        }))
        .catch(err => Observable.of({
          type: FETCH_SUBSCRIPTION_METHODS_FAILURE,
          error: true,
          payload: err,
        })));

export default combineEpics(
  fetch,
  fetchEntityTypesEpic,
  fetchCredentialsTypesEpic,
  fetchAccessTypesEpic,
  fetchLabelsEpic,
  fetchsubscriptionMethodsEpic
);



// WEBPACK FOOTER //
// ./src/app/modules/miscellaneous/epics.js